import type { FunctionComponent } from 'react';
import { type PageContextType, usePage } from '../../../contexts/PageContext';
import { type RebrandingContextProps, useRebranding } from '../../../contexts/RebrandingContext';

const KycCompanyValidationMP: FunctionComponent = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M9 4H6C4.89543 4 4 4.89543 4 6V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V6C20 4.89543 19.1046 4 18 4H15" stroke="#009EE3" strokeWidth="1.5" />
    <rect x="9" y="2" width="6" height="4" rx="1" stroke="#009EE3" strokeWidth="1.5" />
    <path d="M6 9H18" stroke="#009EE3" strokeWidth="1.5" />
    <path d="M6 17H18" stroke="#009EE3" strokeWidth="1.5" />
    <path d="M6 13H18" stroke="#009EE3" strokeWidth="1.5" />
  </svg>
);

const KycCompanyValidationCongratsMP: FunctionComponent = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 4H6C4.89543 4 4 4.89543 4 6V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V6C20 4.89543 19.1046 4 18 4H15" stroke="#00A650" strokeWidth="1.5" />
    <rect x="9" y="2" width="6" height="4" rx="1" stroke="#00A650" strokeWidth="1.5" />
    <path d="M6 9H18" stroke="#00A650" strokeWidth="1.5" />
    <path d="M6 17H18" stroke="#00A650" strokeWidth="1.5" />
    <path d="M6 13H18" stroke="#00A650" strokeWidth="1.5" />
  </svg>
);

const KycCompanyValidationConflictMP: FunctionComponent = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.0007 5.33301H7.33398C6.22941 5.33301 5.33398 6.22844 5.33398 7.33301V27.333C5.33398 28.4376 6.22942 29.333 7.33399 29.333H24.6673C25.7719 29.333 26.6673 28.4376 26.6673 27.333V7.33301C26.6673 6.22844 25.7719 5.33301 24.6673 5.33301H20.0007" stroke="#737373" strokeWidth="1.5" />
    <rect x="12" y="2.66699" width="8" height="5.33333" rx="1" stroke="#737373" strokeWidth="1.5" />
    <path d="M8 12H24" stroke="#737373" strokeWidth="1.5" />
    <path d="M8 22.667H24" stroke="#737373" strokeWidth="1.5" />
    <path d="M8 17.333H24" stroke="#737373" strokeWidth="1.5" />
  </svg>
);

const KycCompanyValidationML: FunctionComponent = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M9 4H6C4.89543 4 4 4.89543 4 6V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V6C20 4.89543 19.1046 4 18 4H15" stroke="#3483FA" strokeWidth="1.5" />
    <rect x="9" y="2" width="6" height="4" rx="1" stroke="#3483FA" strokeWidth="1.5" />
    <path d="M6 9H18" stroke="#3483FA" strokeWidth="1.5" />
    <path d="M6 17H18" stroke="#3483FA" strokeWidth="1.5" />
    <path d="M6 13H18" stroke="#3483FA" strokeWidth="1.5" />
  </svg>
);

export const KycCompanyValidationSVG: FunctionComponent = () => {
  const { isRebrandingEnabled } = useRebranding() as RebrandingContextProps;
  const { platformId } = usePage() as PageContextType;
  return platformId === 'ML' || isRebrandingEnabled ? <KycCompanyValidationML /> : <KycCompanyValidationMP />;
};

export const KycCompanyValidationCongratsSVG: FunctionComponent = () => {
  const { platformId } = usePage() as PageContextType;
  return platformId === 'ML' ? <KycCompanyValidationML /> : <KycCompanyValidationCongratsMP />;
};

export const KycCompanyValidationConflictSVG: FunctionComponent = () => {
  const { platformId } = usePage() as PageContextType;
  return platformId === 'ML' ? <KycCompanyValidationML /> : <KycCompanyValidationConflictMP />;
};
